"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfWebSiteMenuEditViewModel = instanceOfWebSiteMenuEditViewModel;
exports.WebSiteMenuEditViewModelFromJSON = WebSiteMenuEditViewModelFromJSON;
exports.WebSiteMenuEditViewModelFromJSONTyped = WebSiteMenuEditViewModelFromJSONTyped;
exports.WebSiteMenuEditViewModelToJSON = WebSiteMenuEditViewModelToJSON;
exports.WebSiteMenuEditViewModelToJSONTyped = WebSiteMenuEditViewModelToJSONTyped;
/**
 * Check if a given object implements the WebSiteMenuEditViewModel interface.
 */
function instanceOfWebSiteMenuEditViewModel(value) {
    if (!('wsmId' in value) || value['wsmId'] === undefined)
        return false;
    if (!('wsmName' in value) || value['wsmName'] === undefined)
        return false;
    return true;
}
function WebSiteMenuEditViewModelFromJSON(json) {
    return WebSiteMenuEditViewModelFromJSONTyped(json, false);
}
function WebSiteMenuEditViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'wsmMenuNo': json['wsmMenuNo'] == null ? undefined : json['wsmMenuNo'],
        'wsmWebSiteNo': json['wsmWebSiteNo'] == null ? undefined : json['wsmWebSiteNo'],
        'wsmParent': json['wsmParent'] == null ? undefined : json['wsmParent'],
        'wsmId': json['wsmId'],
        'wsmName': json['wsmName'],
        'wsmHyperLink': json['wsmHyperLink'] == null ? undefined : json['wsmHyperLink'],
        'wsmOrder': json['wsmOrder'] == null ? undefined : json['wsmOrder'],
        'wsmWebPageType': json['wsmWebPageType'] == null ? undefined : json['wsmWebPageType'],
        'wsmActive': json['wsmActive'] == null ? undefined : json['wsmActive'],
        'wsmDisplay': json['wsmDisplay'] == null ? undefined : json['wsmDisplay'],
        'wsmFrontPageFlag': json['wsmFrontPageFlag'] == null ? undefined : json['wsmFrontPageFlag'],
    };
}
function WebSiteMenuEditViewModelToJSON(json) {
    return WebSiteMenuEditViewModelToJSONTyped(json, false);
}
function WebSiteMenuEditViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'wsmMenuNo': value['wsmMenuNo'],
        'wsmWebSiteNo': value['wsmWebSiteNo'],
        'wsmParent': value['wsmParent'],
        'wsmId': value['wsmId'],
        'wsmName': value['wsmName'],
        'wsmHyperLink': value['wsmHyperLink'],
        'wsmOrder': value['wsmOrder'],
        'wsmWebPageType': value['wsmWebPageType'],
        'wsmActive': value['wsmActive'],
        'wsmDisplay': value['wsmDisplay'],
        'wsmFrontPageFlag': value['wsmFrontPageFlag'],
    };
}
